import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IProjektZaehlerSorter extends ISorter {
  id?: ISorterExpression;
  zaehler?: ISorterExpression;
}

export const ProjektZaehlerSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('zaehler', 'Zaehler')
];
